import React from "react";
import FreezeDates from "./FreezeDates";
import FreezeDatesDev from "./FreezeDatesDev";

const MonthEnd = () => {
  const envType = window.envType;

  return (
    <div className="proposal-dashboard month-end-config-page">
      <div className="proposal-dashboard__header month-end-config-page__header">
        <h2 className="proposal-dashboard__title">Month End Configuration</h2>
        <p className="proposal-dashboard__subtitle">
          Configure login and issuance freeze date windows
        </p>
      </div>
      {envType === "DEV" ? <FreezeDates /> : <FreezeDatesDev />}
    </div>
  );
};

export default MonthEnd;
